import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('shared.hooks.useSplitViewContent', {
    auditReportPreviewTitle: 'Audit report for "{requestDisplayName}"',
});
